// ...existing code...
import React from "react";
import { motion } from "framer-motion";
import {
  FaNetworkWired,
  FaCloud,
  FaDatabase,
  FaShieldAlt,
  FaLaptopCode,
  FaServer,
  FaRobot,
  FaGlobe,
  FaCogs
} from "react-icons/fa";
import "./ittechnology.css";
import { Link } from "react-router-dom"; // ✅ Import Link

const FEATURES = [
   {
    icon: <FaCloud />,
    title: "Cloud Infrastructure",
    text: "Designing, deploying, and managing secure cloud environments with AWS, Azure, and Google Cloud for scalable operations.",
  },
  {
    icon: <FaNetworkWired />,
    title: "Networking & Connectivity",
    text: "Optimized network solutions that ensure high performance, low latency, and secure connectivity across hybrid environments.",
  },
  {
    icon: <FaDatabase />,
    title: "Data Engineering & Analytics",
    text: "Building robust data pipelines, warehousing, and analytics dashboards for real-time insights and decision-making.",
  },
  {
    icon: <FaRobot />,
    title: "AI & Automation",
    text: "Automating workflows, leveraging AI models, and streamlining IT operations to boost productivity and efficiency.",
  },
  {
    icon: <FaShieldAlt />,
    title: "Cybersecurity Solutions",
    text: "End-to-end protection through threat monitoring, identity management, and vulnerability assessments.",
  },
  {
    icon: <FaServer />,
    title: "DevOps & IT Operations",
    text: "Continuous integration, automated deployments, and infrastructure monitoring for faster, reliable delivery cycles.",
  },


];

const WHY = [
     {
    icon: <FaCogs />,
    title: "Expert IT Engineers",
    text: "Our certified professionals bring deep technical expertise to deliver innovative, scalable technology solutions.",
  },
  {
    icon: <FaLaptopCode />,
    title: "Innovation-driven",
    text: "We constantly adopt the latest technologies to keep your business ahead in the digital race.",
  },
  {
    icon: <FaGlobe />,
    title: "Global Scalability",
    text: "Our IT systems are built to expand seamlessly across geographies and growing business needs.",
  },

];

const Card = ({ icon, title, text, i }) => (
  <motion.article
    className="hc-card"
    initial={{ opacity: 0, y: 18, scale: 0.995 }}
    whileInView={{ opacity: 1, y: 0, scale: 1 }}
    viewport={{ once: true }}
    transition={{ duration: 0.6, delay: i * 0.08 }}
    aria-labelledby={`hc-card-${i}-title`}
  >
    <div className="hc-icon" aria-hidden>
      {icon}
    </div>
    <div className="hc-card-body">
      <h3 id={`hc-card-${i}-title`}>{title}</h3>
      <p>{text}</p>
    </div>
  </motion.article>
);

const SoftwareDevelopment = () => {
  return (
    <main className="it-container">
      {/* Header without external image - decorative gradient + shapes via CSS */}
      <header className="it-header">
             <div className="header-content">
               <h1>IT TECHNOLOGY</h1>
               <p className="subtitle">
               Empowering businesses with cutting-edge IT solutions that enhance efficiency, security, and innovation. We deliver end-to-end technology services, from cloud infrastructure to enterprise digital transformation.
               </p>
     
               <div className="header-ctas">
                  <Link
               to="/contact" // ✅ Navigate to Contact page
               className="btn-primary"
               aria-label="Contact Lyros"
             >
               Talk to our Expert team
             </Link>
               </div>
             </div>
     
             <svg className="header-decor" viewBox="0 0 800 200" preserveAspectRatio="none" aria-hidden="true">
               <defs>
                 <linearGradient id="gB" x1="0" x2="1">
                   <stop offset="0" stopColor="#0ea5e9" stopOpacity="0.14" />
                   <stop offset="1" stopColor="#6366f1" stopOpacity="0.06" />
                 </linearGradient>
               </defs>
               <path d="M0 140 C160 40 360 240 800 80 L800 200 L0 200 Z" fill="url(#gB)"></path>
             </svg>
           </header>

      <section className="container hc-intro">
        <motion.p
          className="section-desc"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
         We craft high-performance software and applications tailored to your unique business needs. From enterprise-grade systems to mobile apps, our development services ensure scalability, reliability, and security. Leveraging the latest in cloud, AI, and agile practices, we deliver digital experiences that drive growth and efficiency.  </motion.p>
      </section>

      <section className="container hc-features">
        <h2 className="section-title">Our Approach</h2>
        <div className="hc-cards">
          {FEATURES.map((f, idx) => (
            <Card key={idx} icon={f.icon} title={f.title} text={f.text} i={idx} />
          ))}
        </div>
      </section>

      <section className="container hc-examples">
        <h2 className="section-title"> Our Technology Services</h2>
        <div className="hc-examples-grid">
          <motion.div
            className="example-card"
            initial={{ opacity: 0, x: -12 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h4>Product Engineering</h4>
            <p>End-to-end development of software products from concept to launch. Focused on usability, scalability, and market readiness.</p>
          </motion.div>

          <motion.div
            className="example-card"
            initial={{ opacity: 0, x: 12 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.08 }}
          >
            <h4>Cloud Transformation</h4>
            <p>Migration, optimization, and modernization of IT infrastructure. Reduce costs, improve agility, and boost system reliability.</p>
          </motion.div>

          <motion.div
            className="example-card"
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.16 }}
          >
            <h4>AI & Machine Learning</h4>
            <p>Build smarter applications with predictive intelligence. Leverage data science for personalization, automation, and insights.</p>
          </motion.div>
        </div>
      </section>

      <section className="container hc-why">
        <h2 className="section-title">Why Choose Lyros</h2>
        <div className="hc-why-grid">
          {WHY.map((w, i) => (
            <motion.div
              className="why-card"
              key={i}
              initial={{ opacity: 0, scale: 0.98 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
            >
              <div className="why-icon" aria-hidden>
                {w.icon}
              </div>
              <div className="why-content">
                <h4>{w.title}</h4>
                <p>{w.text}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </section>
    </main>
  );
};

export default SoftwareDevelopment ;
// ...existing code...